
import ProductDetailHero from './components/ProductDetailHero';
import ProductFeatures from './components/ProductFeatures';
import ProductSpecifications from './components/ProductSpecifications';
import ComplianceSection from './components/ComplianceSection';
import RelatedProducts from './components/RelatedProducts';
import ProductCTA from './components/ProductCTA';

export default function ControlValvesPage() {
  const product = {
    id: 9,
    title: 'Control Valves & Accessories',
    category: 'Fire Suppression Systems',
    brand: 'FlameGuardQA',
    model: 'FG-CV-01',
    certification: 'FM Approved',
    status: 'Available',
    image: 'https://readdy.ai/api/search-image?query=Professional%20fire%20sprinkler%20control%20valves%20and%20butterfly%20valves%20with%20red%20handles%20and%20brass%20fittings%2C%20FM%20approved%20flow%20control%20devices%20for%20fire%20suppression%20systems%20with%20technical%20specifications%20and%20QCDD%20certification%20marking&width=600&height=600&seq=control-valves-detail&orientation=squarish',
    description: 'Butterfly, gate, and flow control valves for efficient sprinkler and hydrant system management. These FM-approved valves ensure reliable flow control and system integrity in fire protection applications.'
  };

  const features = [
    'FM and UL listed valves',
    'Corrosion-resistant body',
    'Tamper switch compatible',
    'Easy operation and maintenance',
    'Multiple size options available',
    'Ductile iron and brass construction',
    'High-pressure rating capability',
    'Professional installation support'
  ];

  const specifications = [
    { label: 'Model', value: 'FG-CV-01' },
    { label: 'Type', value: 'Butterfly/Gate Control Valves' },
    { label: 'Sizes Available', value: '2" to 12"' },
    { label: 'Material', value: 'Ductile Iron / Brass' },
    { label: 'Pressure Rating', value: 'PN16 / PN25' },
    { label: 'Operating Temperature', value: '-10°C to 120°C' },
    { label: 'End Connections', value: 'Flanged/Grooved' },
    { label: 'Seat Material', value: 'EPDM/NBR' },
    { label: 'Handle Type', value: 'Lever/Handwheel' },
    { label: 'Tamper Switch', value: 'Compatible' },
    { label: 'Certification', value: 'FM, UL, QCDD' },
    { label: 'Warranty', value: '5 Years' }
  ];

  const relatedProducts = [
    {
      id: 8,
      title: 'Fire Pump Sets',
      image: 'https://readdy.ai/api/search-image?query=Industrial%20fire%20pump%20system%20with%20electric%20motor%20and%20control%20panel%2C%20NFPA%2020%20compliant%20fire%20suppression%20pump%20equipment%20with%20pressure%20gauges%20and%20QCDD%20certification&width=300&height=200&seq=fire-pumps-related2&orientation=landscape',
      category: 'Pumps',
      compliance: 'NFPA 20 Standard'
    },
    {
      id: 7,
      title: 'Sprinkler Heads & Systems',
      image: 'https://readdy.ai/api/search-image?query=Professional%20fire%20sprinkler%20heads%20installed%20in%20white%20ceiling%20with%20red%20pipes%20and%20brass%20fittings%2C%20UL%20listed%20sprinkler%20system%20with%20various%20temperature%20ratings&width=300&height=200&seq=sprinkler-heads-related2&orientation=landscape',
      category: 'Sprinklers',
      compliance: 'UL Listed'
    },
    {
      id: 13,
      title: 'Fire Hydrant Systems',
      image: 'https://readdy.ai/api/search-image?query=Red%20fire%20hydrant%20system%20with%20hose%20reel%20and%20landing%20valve%20in%20protective%20cabinet%2C%20professional%20fire%20fighting%20equipment%20with%20QCDD%20approval&width=300&height=200&seq=hydrant-system-related3&orientation=landscape',
      category: 'Hydrants',
      compliance: 'BS Standards'
    },
    {
      id: 4,
      title: 'CO₂ Fire Extinguishers',
      image: 'https://readdy.ai/api/search-image?query=Professional%20red%20CO2%20fire%20extinguisher%20with%20black%20horn%20and%20pressure%20gauge%2C%20QCDD%20approved%20clean%20agent%20fire%20suppression%20equipment%20for%20electrical%20fires&width=300&height=200&seq=co2-extinguisher-related&orientation=landscape',
      category: 'Extinguishers',
      compliance: 'QCDD Approved'
    }
  ];

  return (
    <div className="min-h-screen">
      <ProductDetailHero product={product} />
      <ProductFeatures features={features} />
      <ProductSpecifications specifications={specifications} />
      <ComplianceSection />
      <RelatedProducts products={relatedProducts} />
      <ProductCTA />
      
      {/* Floating WhatsApp Button */}
      <div className="fixed bottom-8 right-8 z-50">
        <a 
          href="https://wa.me/97455544093"
          target="_blank"
          rel="noopener noreferrer"
          className="w-14 h-14 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-2xl hover:shadow-3xl transition-all duration-300 flex items-center justify-center group"
        >
          <i className="ri-whatsapp-line text-2xl group-hover:scale-110 transition-transform"></i>
        </a>
      </div>
    </div>
  );
}
